import IdleModal from './IdleModal';

export default IdleModal;
